import { SidebarState } from "@/core/entities/sidebar/SidebarState";
import { ISidebarStateRepository } from "@/core/repositories/sidebarState";
import { LocalStorageAdapter } from "@/infrastructure/adapters/localStorage";
import { JsonSerializer } from "@/infrastructure/serializers/JsonSerializer";
import { createLogger, ILogger } from "@/infrastructure/services/logger";

export class SidebarStateRepository implements ISidebarStateRepository {
  private readonly storage: LocalStorageAdapter;
  private readonly logger: ILogger = createLogger("SidebarStateRepository");
  private readonly SIDEBAR_KEY = "sidebar_state";
  private readonly DEFAULT_STATE: SidebarState = {
    isCollapsed: false,
  };

  constructor() {
    this.storage = new LocalStorageAdapter(new JsonSerializer(), "irApp");
  }

  async getSidebarState(): Promise<SidebarState> {
    try {
      const item = await this.storage.retrieve<SidebarState>(this.SIDEBAR_KEY);
      return item?.value ?? this.DEFAULT_STATE;
    } catch (error) {
      this.logger.error("Failed to get sidebar state", error);
      return this.DEFAULT_STATE;
    }
  }

  async saveSidebarState(state: SidebarState): Promise<void> {
    try {
      await this.storage.store({
        key: this.SIDEBAR_KEY,
        value: {
          ...state,
          lastUpdated: new Date().toISOString(),
        },
      });
    } catch (error) {
      this.logger.error("Failed to save sidebar state", error);
    }
  }

  async resetSidebarState(): Promise<void> {
    try {
      await this.saveSidebarState(this.DEFAULT_STATE);
    } catch (error) {
      this.logger.error("Failed to reset sidebar state", error);
    }
  }
}
